import { render, staticRenderFns } from "./CrossSellHistory.vue?vue&type=template&id=681b5506&"
import script from "./CrossSellHistory.vue?vue&type=script&lang=js&"
export * from "./CrossSellHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports